document.addEventListener("DOMContentLoaded", function () {
    // This script automatically opens the Bootstrap Offcanvas component for a conversation if a "conversation" parameter is present in the URL.
    // http://localhost:3000/fr/tasks/1404258?conversation=3797485&refererto=mail
    // http://localhost:3000/fr/service_requests/1404258?conversation=3797485&refererto=mail
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const conversationId = urlParams.get("conversation");

    if (conversationId) {
        const offcanvasElement = document.getElementById(`offcanvas-conversation-${conversationId}`);

        if (offcanvasElement) {
            // Check if Offcanvas is already shown
            if (!offcanvasElement.classList.contains("show")) {
                const offcanvas = new bootstrap.Offcanvas(offcanvasElement);
                offcanvas.show();
            }
        }
    }
});
